function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.49 7.962h8.246M4.49 10.566h5.208M4.49 5.358h6.076M4.49 13.17h3.472M4.49 15.774h3.472m1.736 5.209H1.885a.868.868 0 01-.868-.868V1.885c0-.479.389-.868.868-.868h11.54c.23 0 .45.092.613.255l3.218 3.218a.864.864 0 01.254.613v2.859"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.566 15.774a5.209 5.209 0 1010.417 0 5.209 5.209 0 00-10.417 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.095 14.26l-2.521 3.362a.656.656 0 01-.982.071L13.29 16.39"
}));

function SvgOffSummaryBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
}

export default SvgOffSummaryBlack;